<template>
    <div class="footer fixed-bottom">
        <div class="d-flex">
            <div id="mouse-position" class="mr-auto p-2 "></div>
            <router-link class="p-2 footer-link" :to="'/' + link">{{
                $t(name)
            }}</router-link>
            <div class="footer-link p-2">|</div>
            <div class="footer-link p-2 pointer" v-on:click.prevent="logout">
                {{ $t("logout") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "footerArea",
    data: function() {
        return {
            data: "",
            link: "Admin",
            name: "admin"
        };
    },
    methods: {
        logout() {
            this.$keycloak.logoutFn();
        }
    },
    mounted() {
        const route = this.$router.currentRoute;

        if (route.name === "admin") {
            this.link = "";
            this.name = "map";
        }
    }
};
</script>

<style scoped lang="stylus">
.footer {
  background-color: #dedede;
  text-align: left;
}

.mouse-parent {
  width: 300px;
  margin: 0;
}

#mouse-position {
  font-size: 12px;
  padding: 5px;
}

.footer-link {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 10px;
}

.pointer {
    cursor: pointer;
}
</style>
